/**
 * Profile page shared constants (specs/profile-page).
 * The screen is a full-screen dark takeover with its own palette (like the Rank Ladder),
 * so colours live here rather than deriving from the light/dark app theme.
 */

export const PROFILE_TEST_IDS = {
  screen: 'profile-screen',
  scroll: 'profile-scroll',
  back: 'profile-back-button',
  settings: 'profile-settings-button',
  avatar: 'profile-avatar-tappable',
  crest: 'profile-rank-crest',
  xpBar: 'profile-xp-bar',
  statPlayed: 'profile-stat-played',
  statWon: 'profile-stat-won',
  statWinRate: 'profile-stat-winrate',
  statStreak: 'profile-stat-streak',
  dailyCard: 'daily-rewards-card',
  dailyCollect: 'daily-rewards-collect',
  h2hCard: 'head-to-head-card',
  h2hEmpty: 'head-to-head-empty',
  h2hError: 'head-to-head-error',
  h2hRetry: 'head-to-head-retry',
  errorRetry: 'profile-error-retry',
} as const;

/** Dark palette taken from the imported design ("Profile Page.dc.html"). */
export const PROFILE_COLORS = {
  screenBg: '#0B0713',
  text: '#F9FAFB',
  textMuted: '#9CA3AF',
  textDim: '#6B7280',
  hairline: 'rgba(255,255,255,0.06)',
  card: '#17122A',
  cardBorder: 'rgba(255,255,255,0.05)',
  purple: '#A78BFA',
  purpleLight: '#C4B5FD',
  track: '#1F1839',
  mint: '#6EE7B7',
  gold: '#FCD34D',
  goldDeep: '#F59E0B',
  lockGrey: '#4B5563',
  nodeIdle: '#141024',
  nodeTodayBg: '#2A1F52',
  avatarRing: '#241150',
  buttonIdleBg: '#141024',
  buttonIdleBorder: '#2E2547',
} as const;

export const PROFILE_LAYOUT = {
  avatarSize: 176,
  crestSize: 84,
  screenMaxWidth: 480,
} as const;
